import { render, staticRenderFns } from "./ModalTrigger.vue?vue&type=template&id=20739e3e&scoped=true&"
import script from "./ModalTrigger.vue?vue&type=script&lang=ts&"
export * from "./ModalTrigger.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTrigger.vue?vue&type=style&index=0&id=20739e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20739e3e",
  null
  
)

export default component.exports